import { render, staticRenderFns } from "./HomeEcdis.vue?vue&type=template&id=6cc160c4&"
import script from "./HomeEcdis.vue?vue&type=script&lang=js&"
export * from "./HomeEcdis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports